import Color from '../Color.js';

export default (...args) => {
    try {
        new Color(...args);
        return true;
        // eslint-disable-next-line
    } catch (e) {
        return false;
    }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/chroma-js/src/utils/valid.js
// module id = 2548
// module chunks = 6